<template>
  <!-- 大会议题 -->
  <div class="AgendaWrap contentBox">
    <router-link class="index-title" :to="{ path: DailyInfo.url, query:{ name: DailyInfo.name, topicId: DailyInfo.id } }" target="_blank">{{ AgendaName }}</router-link>
    <ul class="content">
      <li v-for="(item,index) in AgendaData" :key="index"><router-link :to="{ path: DailyInfo.url, query:{ name: DailyInfo.name, topicId: DailyInfo.id, title: item.name } }">{{ item.name }}<i class="el-icon-arrow-right"></i></router-link></li>
      <!-- 议题 弹窗事件 -->
      <!-- <li v-for="(item,index) in AgendaData" :key="index" @click="LookAgendaInfoFn(index)"><a href="">{{ item.name }}</a></li> -->
    </ul>
  </div>
</template>

<script>
  export default{
    name: 'IndexAgenda',
    props: {
      AgendaName: {
        type: String,
        default: '大会日程'
      },
      AgendaData: {
        type: Array,
        default: () => []
      },
      DailyInfo: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      // 特邀嘉宾信息
      LookAgendaInfoFn(ind) {
        this.$emit('AgendaInfoFn',ind);
      }
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .AgendaWrap {
      overflow: hidden;
    }

    .AgendaWrap ul {
      display: flex;
      flex-wrap: wrap;
    }

    .AgendaWrap li {
      font-size: 16px;
      line-height: 36px;
      color: #ffffff;
      background: url(../assets/image/point.png) no-repeat 0 center;
      background-size: 10px 10px;
      padding: 0 20px;
      width: 33%;
      position: relative;
      top: 100vh;
      cursor: pointer;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .AgendaWrap {
      overflow: hidden;
    }

    .AgendaWrap li {
      font-size: .32rem;
      line-height: .56rem;
      color: #ffffff;
      background: url(../assets/image/point.png) no-repeat 0 10px;
      background-size: .16rem .16rem;
      padding-left: 15px;
      position: relative;
      top: 100vh;
    }
  }
  .AgendaWrap .main_news_active {
    transition: all 1s;
    opacity: 1 !important;
    top: 0;
  }

  .AgendaWrap li a{
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexAgenda.vue